import dayjs from "dayjs";
import './overview-shift.scss';

interface OverviewShiftProps {
    shift: any
}

export function OverviewShift(props: OverviewShiftProps) {
    const start = dayjs(props.shift.start);
    const end = dayjs(props.shift.end);
    const timeFormat = !start.isSame(end, 'day') ? 'DD/MM HH:mm' : 'HH:mm';

    return (
        <div className="OverviewShift">
            <div className="header">
                <div className="times">
                    <span>{start.format(timeFormat)}</span>
                    <span>{end.format(timeFormat)}</span>
                </div>
                <div className="details" style={{ "--shift-color": "#" + props.shift.activityType.backColor } as React.CSSProperties}>
                    <span className="name">
                        {props.shift.activityType.shortName}
                    </span>
                    <span className="meta">
                        {props.shift.activityType.displayName}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default OverviewShift